const roundMoney = (value) => {
  const parsed = Number(value || 0);
  if (!Number.isFinite(parsed)) return 0;
  return Number(parsed.toFixed(2));
};

export const getVoucherPaymentBreakdown = ({ subtotal = 0, voucher = null, recargo = 0 } = {}) => {
  const subtotalNormalizado = Math.max(roundMoney(subtotal), 0);
  const recargoNormalizado = Math.max(roundMoney(recargo), 0);
  const descuento = voucher
    ? Math.min(Math.max(roundMoney(voucher?.montoDescuento || 0), 0), subtotalNormalizado)
    : 0;
  const total = Math.max(roundMoney(subtotalNormalizado + recargoNormalizado - descuento), 0);

  return {
    subtotal: subtotalNormalizado,
    descuento,
    recargo: recargoNormalizado,
    total,
    cubiertoCompletamente: Boolean(voucher) && total <= 0.01,
    requierePagoComplementario: Boolean(voucher) && total > 0.01,
  };
};

export const cuentaCorrienteCubreRemanente = ({ disponible = 0, remanente = 0 } = {}) =>
  roundMoney(disponible) + 0.01 >= roundMoney(remanente);

export { roundMoney };
